import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "search-bar-container" }
const _hoisted_2 = { class: "search-fields" }
const _hoisted_3 = { class: "search-field" }
const _hoisted_4 = { class: "search-field" }
const _hoisted_5 = { class: "search-field" }
const _hoisted_6 = { class: "search-field" }
const _hoisted_7 = { class: "search-buttons" }
const _hoisted_8 = { class: "stats-and-actions" }
const _hoisted_9 = { class: "table-stats" }
const _hoisted_10 = { class: "stat-item" }
const _hoisted_11 = { class: "action-buttons" }
const _hoisted_12 = { class: "phone-cell" }
const _hoisted_13 = { class: "id-card-cell" }
const _hoisted_14 = { class: "text-ellipsis" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-ellipsis" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-ellipsis" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "decorate-box" }
const _hoisted_21 = { class: "tags-container" }
const _hoisted_22 = {
  key: 0,
  class: "tag-more"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "edit" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "pagination-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_View = _resolveComponent("View")!
  const _component_Hide = _resolveComponent("Hide")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_DrawerEmployeeDetail = _resolveComponent("DrawerEmployeeDetail")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.searchText.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList.searchText.value) = $event)),
              placeholder: _ctx.searchList.searchText.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.phone.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.phone.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchList.phone.value) = $event)),
              placeholder: _ctx.searchList.phone.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.idCardNo.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.idCardNo.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchList.idCardNo.value) = $event)),
              placeholder: _ctx.searchList.idCardNo.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.labelIds.name), 1),
            _createVNode(_component_el_select, {
              modelValue: _ctx.searchList.labelIds.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchList.labelIds.value) = $event)),
              placeholder: _ctx.searchList.labelIds.placeholder,
              clearable: "",
              multiple: "",
              filterable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": true,
              "max-collapse-tags": 2,
              "filter-method": _ctx.filterLabels,
              onChange: _ctx.handleLabelChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLabelOptions, (opt) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value,
                    disabled: _ctx.isLabelDisabled(opt.value)
                  }, null, 8, ["label", "value", "disabled"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "filter-method", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSearch
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.handleReset }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("重置")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, "共" + _toDisplayString(_ctx.statistics.totalCount || 0) + "人：男" + _toDisplayString(_ctx.statistics.menCount || 0) + "人 / 女" + _toDisplayString(_ctx.statistics.womenCount || 0) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            class: "batch-undo-btn",
            onClick: _ctx.handleBatchTag
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode(" 批量撤销 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_tableComponent, {
        class: "mg-t-10",
        "table-data": _ctx.tableData,
        "table-head": _ctx.tableHead,
        "row-key": "id",
        onSelectionChange: _ctx.handleSelectionChange
      }, {
        phone: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.maskedFields.phone ? _ctx.formatPhone(scope.row.phone) : scope.row.phone), 1),
            _createVNode(_component_el_icon, {
              class: "toggle-icon",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.maskedFields.phone = !_ctx.maskedFields.phone))
            }, {
              default: _withCtx(() => [
                (_ctx.maskedFields.phone)
                  ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
              ]),
              _: 1
            })
          ])
        ]),
        sex: _withCtx((scope) => [
          _createElementVNode("view", null, _toDisplayString(scope.row.sex === '0' ? '男' : '女'), 1)
        ]),
        idCardNo: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.maskedFields.idCard ? _ctx.formatIdCard(scope.row.idCardNo) : scope.row.idCardNo), 1),
            _createVNode(_component_el_icon, {
              class: "toggle-icon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.maskedFields.idCard = !_ctx.maskedFields.idCard))
            }, {
              default: _withCtx(() => [
                (_ctx.maskedFields.idCard)
                  ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
              ]),
              _: 1
            })
          ])
        ]),
        workerName: _withCtx((scope) => [
          (scope.row.workerName && scope.row.workerName.length > 7)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.workerName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(scope.row.workerName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.workerName), 1))
        ]),
        isResign: _withCtx((scope) => [
          _createElementVNode("span", {
            class: _normalizeClass(['status-badge', scope.row.isResign === 0 ? 'status-working' : 'status-left'])
          }, _toDisplayString(scope.row.isResign === 0 ? '在职' : '离职'), 3)
        ]),
        projectName: _withCtx((scope) => [
          (scope.row.projectName && scope.row.projectName.length > 12)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.projectName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(scope.row.projectName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(scope.row.projectName), 1))
        ]),
        serveCompanyName: _withCtx((scope) => [
          (scope.row.serveCompanyName && scope.row.serveCompanyName.length > 12)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.serveCompanyName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(scope.row.serveCompanyName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row.serveCompanyName), 1))
        ]),
        insureStatus: _withCtx((scope) => [
          _createElementVNode("span", {
            class: _normalizeClass(['status-tag', scope.row.insureStatus === 1 ? 'status-active' : 'status-inactive'])
          }, _toDisplayString(scope.row.insureStatus === 1 ? '已投保' : '未投保'), 3)
        ]),
        isLogout: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "decorate",
              style: _normalizeStyle({
                        background: scope.row.isLogout === 0 ? '#00D679' : '#FF7642'
                    })
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString(scope.row.isLogout === 0 ? '正常' : '已注销'), 1)
          ])
        ]),
        labels: _withCtx((scope) => [
          (scope.row.labels && scope.row.labels.length > 0)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.labels.map((tag) => tag.labelName).join('、'),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.labels.slice(0, 2), (tag, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag-item"
                      }, _toDisplayString(_ctx.truncateText(tag.labelName, 5)), 1))
                    }), 128)),
                    (scope.row.labels.length > 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, " +" + _toDisplayString(scope.row.labels.length - 2), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, "--"))
        ]),
        operate: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "edit-left",
              onClick: ($event: any) => (_ctx.handleRowUndo(scope.row))
            }, "撤销离职", 8, _hoisted_25),
            _createElementVNode("div", {
              class: "edit-right",
              onClick: ($event: any) => (_ctx.handleDetail(scope.row))
            }, "详情", 8, _hoisted_26)
          ])
        ]),
        _: 1
      }, 8, ["table-data", "table-head", "onSelectionChange"]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pageInfo.pageNum,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageInfo.pageNum) = $event)),
          "page-size": _ctx.pageInfo.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageInfo.pageSize) = $event)),
          "page-sizes": [10, 20, 50],
          total: _ctx.pageInfo.total,
          layout: "total, sizes, prev, pager, next, jumper",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ]),
      (_ctx.imageViewerVisible)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "url-list": _ctx.previewImages,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.imageViewerVisible = false))
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true),
      _createVNode(_component_DrawerEmployeeDetail, {
        show: _ctx.detailDrawerVisible,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detailDrawerVisible) = $event)),
        "employee-data": _ctx.detailEmployeeData
      }, null, 8, ["show", "employee-data"])
    ]),
    _: 1
  }))
}